






































import Vue from 'vue';
import {
    CandidateProfileAction,
    CandidateProfileScorer,
    CandidateProfileStatus,
    ProfileRequirementType,
} from '~/utils/candidate/CandidateProfileScorer';

export default Vue.extend({
    name: 'BeDiscoveredModal',
    props: {
        scorer: {
            type: Object as () => CandidateProfileScorer,
            required: true,
        },
    },
    data() {
        return {
            CandidateProfileStatus,
        };
    },
    computed: {
        actions(): CandidateProfileAction[] {
            return this.scorer
                .getCandidateProfileActions(ProfileRequirementType.ONLY_BE_DISCOVERED_REQUIREMENT)
                .sort((a, b) => (b.priority || 0) - (a.priority || 0));
        },
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
    },
});
